import { createAsyncThunk } from '@reduxjs/toolkit';

import { ContentCompetencyProficiency } from '@backrs_ui/common-ui';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchProficienciesForAllCompetencies = createAsyncThunk(
  'contentCompetency/fetchProficienciesForAllCompetencies',
  async (_, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-competency/proficiency`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentCompetencyProficiency[];
    } catch (error) {
      return rejectWithValue(
        `Failed to fetch content competency proficiencies with error: ${error}`,
      );
    }
  },
);

export const postProficiencyForCompetency = createAsyncThunk(
  'contentCompetency/postProficiencyForCompetency',
  async (payload: ContentCompetencyProficiency, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-competency/proficiency`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentCompetencyProficiency[];
    } catch (error) {
      return rejectWithValue(`Failed to post content competency proficiency with error: ${error}`);
    }
  },
);
